import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import HomePage from "@/pages/HomePage";
import MeasuresListPage from "@/pages/MeasuresListPage";
import MeasureReportPage from "@/pages/MeasureReportPage";
import BrowseMeasuresPage from "@/pages/BrowseMeasuresPage";
import RecentBillsPage from "@/pages/RecentBillsPage";
import SupportPage from "@/pages/SupportPage";
import SupportThanksPage from "@/pages/SupportThanksPage";
import DossierRequestPage from "@/pages/DossierRequestPage";
import DossierThanksPage from "@/pages/DossierThanksPage";
import AdminPage from "@/pages/AdminPage";
import HelpButton from "@/components/HelpButton";

function buildBugReportMailto() {
  const subject = "Measure X-Ray bug report";
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const body = [
    "Thanks for taking the time to report this — it really helps.",
    "",
    "What happened (what you were trying to do, and what went wrong):",
    "",
    "",
    "Steps to reproduce (so I can see the bug myself):",
    "1. ",
    "2. ",
    "3. ",
    "",
    "URL of the page where the bug happened:",
    "",
    "",
    "Browser + device (e.g., Chrome on Pixel 7, Safari on iPhone, Firefox on Mac):",
    "",
    "",
    "If possible, please ATTACH A SCREENSHOT showing the bug. A screenshot is",
    "almost always more useful than a description. Drop the image directly into",
    "this email before sending.",
    "",
    "Anything else I should know:",
    "",
    "",
    "— Sent from Measure X-Ray",
    origin ? `Page: ${origin}` : "",
  ].filter(Boolean).join("\n");

  return `mailto:D20Nat21@gmail.com?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
}

function App() {
  useEffect(() => {
    document.title = "Measure X-Ray — Bills + ballot measures";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/measures" element={<MeasuresListPage />} />
            <Route path="/measures/browse" element={<BrowseMeasuresPage />} />
            <Route path="/measures/:id" element={<MeasureReportPage />} />
            <Route path="/recent-bills" element={<RecentBillsPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/support/thanks" element={<SupportThanksPage />} />
            <Route path="/dossier" element={<DossierRequestPage />} />
            <Route path="/dossier/thanks" element={<DossierThanksPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
        <footer className="max-w-6xl mx-auto px-5 sm:px-8 py-10 mt-10 border-t border-[hsl(var(--rule))] text-[11px] font-mono uppercase tracking-wider text-[hsl(var(--ink-muted))] flex items-center justify-between flex-wrap gap-3">
          <span data-testid="footer-disclaimer">
            Measure X-Ray · Bills + ballot measures · Evidence-first · Never tells you how to vote
          </span>
          <span className="flex items-center gap-3 flex-wrap">
            <a
              href={buildBugReportMailto()}
              data-testid="footer-bug-report-link"
              className="hover:text-[hsl(var(--ink))] transition-colors underline-offset-2 hover:underline"
              title="Open your email client with a bug-report template"
            >
              Report a bug
            </a>
            <span>California MVP · Phase 1-2</span>
          </span>
        </footer>
        <Toaster />
        <HelpButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
